import APIService from '../../services/api'

import { GET_CATALOG, FETCH_CATALOG, UPDATE_CATALOG, ERROR_API } from './constants'

export const actionsCatalog = {
  [GET_CATALOG] ({commit, state},
    { id }) {
    commit(FETCH_CATALOG)
    APIService.getCatalog(id)
    .then(json => {
      commit(UPDATE_CATALOG, {
        result: json || []
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsCatalog



// WEBPACK FOOTER //
// ./src/store/search/actions.catalog.js